import styles from './card-info.module.css'
import { CardInfoProps } from './card-info.types'
import { Skeleton, Text } from '@mercai/clever'

export const CardInfo = ({
  title,
  actions,
  icon,
  children,
  className,
  items,
  isLoading,
  hasHeader = true,
}: CardInfoProps) => {
  const size: Record<number, string> = {
    0: '25%',
    1: '45%',
    2: '35%',
    3: '60%',
    4: '15%',
    5: '20%',
  }

  return (
    <div className={`${styles.container} ${className}`}>
      {hasHeader && (
        <div className={styles.header}>
          <div className={styles['title-container']}>
            {icon}
            <div className={styles.title}>{title || ''}</div>
          </div>
          <div className={styles['actions-container']}>{actions}</div>
        </div>
      )}
      {items && (
        <div className={styles.content}>
          {items.map((item, index) => (
            <Text
              key={`item-${index}`}
              variant="text-base"
              className={styles.row}
            >
              <strong>
                {isLoading ? (
                  <Skeleton width={size[index % 6]} height="1rem" />
                ) : (
                  item.label
                )}
              </strong>{' '}
              <div>
                {isLoading ? (
                  <Skeleton width="50%" height="1rem" />
                ) : (
                  item.value
                )}
              </div>
            </Text>
          ))}
        </div>
      )}
      {children && <div className={styles.content}>{children}</div>}
    </div>
  )
}
